import ms from 'ms'
import { useRef } from 'react'
import { hooks } from '@adc/ui-core'
import { performFreshnessCheck } from '../components/auctionApplication/queries/applicationSessionInformation'

const useFreshnessDetection = () => {
  // We use this state with the interval below to remember whether the user was logged in the last time we checked.
  const loggedInRef = useRef({ wasLoggedIn: false })
  hooks.useInterval(() => {
    performFreshnessCheck(loggedInRef)
  }, ms('2m'))
}

export default useFreshnessDetection
